import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpContextToken,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export const IS_MESSENGER = new HttpContextToken<boolean>(() => false);
export const IS_TELEPHONY = new HttpContextToken<boolean>(() => false);
export const IS_API = new HttpContextToken<boolean>(() => false);

export function getContext(type: string) {
  if (type == 'messenger') {
    return new HttpContext().set(IS_MESSENGER, true);
  } else if (type == 'telephony') {
    return new HttpContext().set(IS_TELEPHONY, true);
  }
  return new HttpContext().set(IS_API, true);
}

/**
 * Prefixes all requests with `environment.serverUrl`.
 */

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!/^(http|https):/i.test(request.url)) {
      if (request.context.get(IS_MESSENGER) === true) {
        request = request.clone({
          url: environment.messenger.url + environment.messenger.server + request.url,
        });
      } else if (request.context.get(IS_TELEPHONY) === true) {
        request = request.clone({
          url: environment.telephony.url + environment.telephony.server + request.url,
        });
      } else {
        request = request.clone({
          url: environment.api.url + environment.api.server + request.url,
        });
      }
    }
    return next.handle(request);
  }
  configure(context: any): ApiPrefixInterceptor {
    return this;
  }
}
